import { HttpStatusCode } from 'data/protocols/http';
import { InvalidCredentialsError, UnexpectedError } from 'domain/errors';
import { CancelRecurringPushNotificationUseCaseInterface } from 'domain/usecases';

export class RemoteCancelRecurringPushNotification
  implements CancelRecurringPushNotificationUseCaseInterface
{
  constructor(
    private readonly url: string,
    private readonly httpClient,
  ) {}

  async execute(
    params: CancelRecurringPushNotificationUseCaseInterface.Params,
  ): Promise<CancelRecurringPushNotificationUseCaseInterface.Result> {
    const httpResponse = await this.httpClient.request({
      url: this.url + `/${params.id}`,
      method: 'patch',
    });

    switch (httpResponse.statusCode) {
      case HttpStatusCode.ok:
        return httpResponse.body;
      case HttpStatusCode.unauthorized:
        throw new InvalidCredentialsError();
      default:
        throw new UnexpectedError(httpResponse.body?.message);
    }
  }
}
